export default __webpack_public_path__ + "static/media/logo_3in1.ec27c486.png";